import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Home from "./Home";
import Login from "./Login";
import SignUp from "./SignUp";
import Survey from "./survey/Survey";
import Live from "./live/Live";
import { AuthProvider } from "./Auth";
import PrivateRoute from "./PrivateRoute";

export default class App extends React.Component {
	componentDidMount() {
		this.pathname = window.location.pathname;
	}
	render() {
		return (
			<AuthProvider>
				<Router>
					<div
						style={{
							alignItems: "center",
							justifyContent: "center",
							height: "100vh",
						}}
					>
						<PrivateRoute exact path="/" component={Home} />
						<PrivateRoute exact path="/survey" component={Survey} />
						<PrivateRoute exact path="/live" component={Live} />
						<Route
							exact
							path="/login"
							component={() => <Login pathname={this.pathname} />}
						/>
						<Route exact path="/signup" component={SignUp} />
					</div>
				</Router>
			</AuthProvider>
		);
	}
}
